import type { MenuBadgeItem } from '#/api/modules/common/types/menu-badge'

import { ref } from 'vue'

import { useAccessStore } from '@vben/stores'

import { defineStore } from 'pinia'

import { menuBadgeApi } from '#/api/modules/common/menu-badge'
import { isInMicroApp } from '#/micro-app'

export const useMenuBadgeStore = defineStore('menu-badges', () => {
  const accessStore = useAccessStore()
  const items = ref<MenuBadgeItem[]>([])
  let requestVersion = 0

  function $reset() {
    requestVersion += 1
    items.value = []
  }

  async function refresh(): Promise<void> {
    const token = accessStore.accessToken
    if (isInMicroApp() || !token || !accessStore.isAccessChecked) return

    const version = ++requestVersion
    try {
      const response = await menuBadgeApi.queryCounts()
      if (version === requestVersion && token === accessStore.accessToken) {
        items.value = response?.items ?? []
      }
    } catch (error) {
      // 角标查询失败保留上次结果，不影响已成功的反馈。
      console.error('查询菜单角标失败', error)
    }
  }

  return { $reset, items, refresh }
})
